import * as React from 'react';
import { ACCOUNT_ROLES } from '@/constants/account-roles';
import { COMMUNITY_ROLES } from '@/constants/community-roles';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import { CalendarV2Page } from '@/pages/v2/calendar';
import { RoleGuard } from '@/components/auth/guards/role-guard';

export const route: RouteObject = {
  path: '/',
  element: (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
  children: [
    {
      path: paths.calendar.index,
      element: (
        <RoleGuard
          requiredAccountRoles={[ACCOUNT_ROLES.ACCOUNT_ADMIN]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER]}
        >
          <CalendarV2Page />
        </RoleGuard>
      ),
    },
  ],
};
